import React from "react";
import { RightArrowIcon } from "../../../styles/img/svg/RightArrowIcon";
import { RightArrowCircleIcon } from "../../../styles/img/svg/RightArrowCircleIcon";

export const UiScheduleCard = (props) => {
  return (
    <>
      <div
        className="df-fav-item df-fav-itm-card df-schedule-card"
        onClick={props.onClick}
      >
        <div className="df-fav-item__logo df-schedule-card__logo">
          {props.logo}
        </div>

        <div className="df-schedule-item__title df-schedule-card__title ">
          <h4>{props.title}</h4>

          {props?.subtext && (
            <div className="df-schedule-card__sub">
              <h6>{props?.subtext}</h6>
            </div>
          )}
        </div>

        {!props.isRightIconWithCircle ? (
          <RightArrowIcon />
        ) : (
          <RightArrowCircleIcon />
        )}
      </div>
    </>
  );
};
